import React from "react";
import "./App.scss";
import Routing from "./Routes";
import { useFirebase } from "./hooks/useFirebase";

const App = () => {
  // Initialize Firebase on app start
  useFirebase();

  return <Routing />;
};

export default App;
